var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuoteStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 63,
    viewBox: "0 0 80 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0 41.1183C0 55.0649 8.89841 63 18.7588 63C27.6572 63 35.1126 55.5458 35.1126 46.4084C35.1126 37.5115 28.8597 31.2595 20.6828 31.2595C19.2398 31.2595 17.3158 31.7405 16.5943 31.9809C18.2778 23.8053 26.2142 13.9466 33.9101 9.37786L22.6068 0C9.3794 9.37786 0 24.5267 0 41.1183ZM44.492 41.1183C44.492 55.0649 53.3904 63 63.2508 63C72.1492 63 79.6047 55.5458 79.6047 46.4084C79.6047 37.5115 73.3517 31.2595 65.1748 31.2595C63.7318 31.2595 61.8078 31.7405 61.0863 31.9809C62.7698 23.8053 70.7062 13.9466 78.4022 9.37786L67.0988 0C53.8714 9.37786 44.492 24.5267 44.492 41.1183Z",
    fill: "#302F68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteStart);
export default __webpack_public_path__ + "static/media/quote-start.b6de95fcb46aec7e679242cb7ee8cf4c.svg";
export { ForwardRef as ReactComponent };